<template>
  <div class="page">
    <!--banner-->
    <div class="banner">
      <div class="bannerCon">
        <p class="title">中科水研</p>
        <p class="info">
          推进国家“02科技重大专项”成果向江西落地，支撑江西“智慧水利”顶层规划，充分发挥科技创新成果转化对产业应用发展的支撑引领作用，提升科技成果资源核心竞争力，江西省水投与中科院微系统所共同组建
          “中科水研（江西）科技股份有限公司”。
        </p>
      </div>
    </div>
    <!--公司简介-->
    <div class="about">
      <p>
        中科水研（江西）科技股份有限公司由江西省水利投资集团与中国科学院上海微系统与信息技术研究所于2019年共同组建，是一家同时拥有产品及研发能力的整体解决方案提供商。公司以服务涉水行业、不断发掘生态资源为目标，规划构建成果转化产业园，以资金、技术、知识产权和产业园为纽带，通过对涉水产业政策与相关技术方案研究，孵化器构建、产业园建设，全面提升科技成果资源核心竞争力。
      </p>
      <p>
        公司以突破重大产业核心技术和引领未来产业发展为目标，组织前瞻性技术和应用研发，促进新成果、新技术向涉水行业的转移转化，全面提升科技成果资源核心竞争力。
      </p>
    </div>
    <!--新闻中心-->
    <div class="news">
      <div class="newsHead">
        <p class="title">新闻资讯</p>
        <a class="btn-1" @click="moreNews">
          <div>更多</div>
          <div>》</div>
        </a>
      </div>
      <div class="newsCon">
        <a
          class="newsBox"
          v-for="item in newsList"
          :key="item.id"
          @click="goToNews(item.id, 1)"
        >
          <img :src="'http://122.112.172.47/imgs/' + item.coverPic" />
          <p class="newsTitle">{{ item.title }}</p>
          <p class="newsInfo">
            {{ item.abstract }}
          </p>
        </a>
      </div>
    </div>
    <!--产品案例-->
    <div class="case">
      <div class="caseHead">
        <P>产品案例</P>
      </div>
      <div class="caseCon">
        <div class="caseBox">
          <P class="caseType">自有产品 </P>
          <div class="caseList">
            <a
              v-for="item in proList"
              @click="chooseCase(item.active, item.index)"
              :key="item.index"
            >
              {{ item.title }}
            </a>
          </div>
          <a class="btn-1" @click="moreCase(0)">
            <div>更多</div>
            <div>》</div></a
          >
        </div>
        <div class="caseBox">
          <P class="caseType">解决方案 </P>
          <div class="caseList">
            <a
              v-for="item in solutionList"
              @click="chooseCase(item.active, item.index)"
              :key="item.index"
            >
              {{ item.title }}
            </a>
          </div>
          <a class="btn-1" @click="moreCase(1)">
            <div>更多</div>
            <div>》</div></a
          >
        </div>
        <div class="caseBox caseBox-2" @click="chooseCase(2, 0)">
          <P class="caseType">成功案例 </P>
          <div class="success">
            <a>水利物联网</a>
          </div>
        </div>
      </div>
    </div>
    <!--友情链接-->
    <div class="link">
      <div class="linkHead">
        <p>友情链接</p>
      </div>
      <div class="linkCon">
        <select v-model="linkValue">
          <option value="">请选择</option>
          <option value="http://www.cas.cn/">中国科学院</option>
          <option value="http://www.sim.ac.cn/"
            >中国科学院微系统与信息技术研究所</option
          >
        </select>
        <select v-model="linkValue">
          <option value="">请选择</option>
          <option value="http://www.jxsltz.com/"
            >江西省水利投资集团有限公司</option
          >
        </select>
        <select v-model="linkValue">
          <option value="">请选择</option>
          <option value="http://www.mwr.gov.cn/">中华人民共和国水利部</option>
          <option value="http://slt.jiangxi.gov.cn/">江西省水利厅</option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
// import { getHotNews } from "../config/newsDataList";
import { getNewsHome } from "../api/newsApi";

export default {
  name: "Index",
  data() {
    return {
      newsList: [],
      linkValue: "",
      proList: [
        { title: "专用超声波传感芯片与设备", active: 0, index: 0 },
        { title: "窄带低功耗安全通信芯片与模组", active: 0, index: 1 },
        { title: "专用SIP一体化封装技术与芯片", active: 0, index: 2 },
        { title: "多参数水质分析传感器", active: 0, index: 3 }
      ],
      solutionList: [
        { title: "井盖监控系统", active: 1, index: 2 },
        { title: "径流一体化监测系统", active: 1, index: 3 },
        { title: "水质监测数据记录方案", active: 1, index: 4 },
        { title: "河(湖)长制设备与解决方案", active: 1, index: 1 }
      ]
    };
  },
  created() {
    getNewsHome().then(res => {
      console.log(res);
      this.newsList = res.data;
    });
  },
  watch: {
    linkValue(newVal) {
      window.location.href = newVal;
    }
  },
  methods: {
    goToNews(id, type) {
      const that = this;
      that.$store.commit("updateMenuItem", {
        title: "新闻资讯",
        path: "/news"
      });
      that.$store.commit("updateNewsClick", { active: 0, currentPage: 1 })
      that.$router.push("/detail/news/" + id);
    },
    moreNews() {
      const that = this;
      const item = { title: "新闻资讯", path: "/news" };
      that.$store.commit("updateMenuItem", item);
      that.$router.push(item.path);
    },
    moreCase(active) {
      const that = this;
      const item = { title: "产品案例", path: "/case" };
      that.$store.commit("updateMenuItem", item);
      that.$store.commit("updateProductsIndex", 0);
      that.$store.commit("updateSolutionsIndex", 0);
      that.$store.commit("updateCaseSuccsIndex", 0);
      that.$store.commit("updateCaseActive", active);
      that.$router.push(item.path);
    },
    chooseCase(active, index) {
      const that = this;
      const item = { title: "产品案例", path: "/case" };
      that.$store.commit("updateMenuItem", item);
      that.$store.commit("updateProductsIndex", 0);
      that.$store.commit("updateSolutionsIndex", 0);
      that.$store.commit("updateCaseSuccsIndex", 0);
      if (active === 0) {
        that.$store.commit("updateProductsIndex", index);
      } else if (active === 1) {
        that.$store.commit("updateSolutionsIndex", index);
      } else {
        that.$store.commit("updateCaseSuccsIndex", index);
      }
      that.$store.commit("updateCaseActive", active);
      that.$router.push(item.path);
    }
  }
};
</script>
<style scoped>
@import "../assets/css/main.css";
.banner {
  width: 100%;
  height: 600px;
  background: url("../assets/img/about/topMenuBg.png") repeat-x,
    url("../assets/img/home/banner.png") no-repeat center;
  /*background:url("../assets/img/about/home.png") repeat-x;*/
  margin-top: -100px;
}
.banner .bannerCon {
  width: 1280px;
  margin: 0 auto;
  position: relative;
  height: 600px;
  pointer-events: none;
}
.banner .bannerCon .title {
  padding-top: 220px;
  font-size: 60px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 90px;
}
.banner .bannerCon .info {
  width: 665px;
  font-size: 18px;
  color: rgba(255, 255, 255, 1);
  line-height: 36px;
  text-align: justify;
}
.banner .bannerCon .arrowCon {
  display: flex;
  position: absolute;
  left: 0;
  bottom: 40px;
}
.banner .bannerCon .arrowCon img {
  margin-right: 10px;
}
.about {
  width: 1280px;
  margin: 0 auto 60px;
  position: relative;
  padding-top: 0px;
}
.about p {
  width: 1200px;
  font-size: 18px;
  font-weight: 400;
  color: #272727;
  line-height: 36px;
  margin-top: 20px;
  text-align: justify;
}
.about img {
  position: absolute;
  right: 0;
  bottom: 0;
}
.news {
  width: 1280px;
  margin: 0 auto 60px;
}
.news .newsHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.news .newsHead p {
  font-size: 30px;
  font-weight: bold;
  color: rgba(40, 40, 40, 1);
  line-height: 60px;
}
.news .newsCon {
  display: flex;
  justify-content: space-between;
  width: 1280px;
}
.news .newsCon .newsBox {
  width: 300px;
}
.news .newsCon .newsBox img {
  width: 300px;
}
.news .newsCon .newsBox .newsTitle {
  width: 300px;
  height: 60px;
  font-size: 24px;
  font-weight: bold;
  color: rgba(24, 24, 24, 1);
  line-height: 60px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.news .newsCon .newsBox .newsInfo {
  width: 300px;
  height: 48px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(24, 24, 24, 1);
  line-height: 24px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.case {
  background: url("../assets/img/home/logo-bg.png") no-repeat right #f8f8f8;
  padding-top: 60px;
}
.case .caseHead {
  width: 1280px;
  margin: 0 auto 20px;
}
.case .caseHead p {
  font-size: 30px;
  font-weight: bold;
  line-height: 60px;
}
.case .caseCon {
  display: flex;
  width: 1280px;
  margin: 0 auto;
  padding-bottom: 60px;
  border-bottom: 1px solid #d8d8d8;
  justify-content: space-between;
}
.case .caseCon .caseBox {
  /*width: 300px;*/
  margin-right: 40px;
  position: relative;
  height: 420px;
}
.case .caseCon .caseBox .caseType {
  font-size: 24px;
  color: rgba(39, 39, 39, 1);
  line-height: 30px;
  margin-bottom: 40px;
}
.case .caseCon .caseBox .caseList a {
  display: block;
  font-size: 18px;
  color: #0588cd;
  line-height: 18px;
  margin: 40px 0;
  border-left: 2px solid #0588cd;
  padding-left: 15px;
  box-sizing: border-box;
}
.case .caseCon .caseBox .btn-1 {
  position: absolute;
  left: 0;
  bottom: 0;
}
.case .caseCon .caseBox-2 {
  width: 630px;
  margin-right: 0;
}
.case .caseCon .caseBox-2 .success {
  width: 630px;
  height: 348px;
  background: url("../assets/img/home/case.png") no-repeat;
  position: relative;
}
.case .caseCon .caseBox-2 .success a {
  width: 660px;
  font-size: 18px;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
  position: absolute;
  left: 20px;
  bottom: 20px;
}
.link {
  width: 100%;
  background-color: #f8f8f8;
  padding-bottom: 40px;
}
.link .linkHead {
  width: 1280px;
  margin: 0 auto 20px;
  font-size: 30px;
  font-weight: bold;
  color: rgba(40, 40, 40, 1);
  line-height: 60px;
  padding-top: 40px;
}
.link .linkCon {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.link .linkCon select {
  width: 400px;
  height: 40px;
  padding: 0 10px;
  box-sizing: border-box;
  border: 1px dashed #d8d8d8;
  text-align: center;
  color: #0588cd;
  font-size: 14px;
  line-height: 40px;
}

.link .linkCon select option {
  text-align: center;
  color: #0588cd;
  font-size: 14px;
  line-height: 40px;
}
</style>
